import { gql } from "@apollo/client";

// CTO todo copy in create
export const CREATE_FEED_CURVE = gql`
  mutation Create($domain: String!, $name: String!) {
    feedCurve {
      create(domain: $domain, name: $name) {
        code
        success
        message
        updatedValues {
          feedcurve_id
          name
          feedLimit
          passFeed
          stimuli
        }
      }
    }
  }
`;

export interface CreateFeedCurveResponse {
  createFeedCurve: CreateFeedCurve 
}

interface CreateFeedCurve {
    code: String
    success: Boolean
    message: string
    updatedValues: CreateFeedCurveUpdatedValues[]
  }

interface CreateFeedCurveUpdatedValues {
  feedcurve_id: number,
  name: string,
  feedLimit: number,
  passFeed: number,
  stimuli: number
}